export default __webpack_public_path__ + "static/media/black-bench-background@2x.8a50acb7.jpg";